import React, { useContext,useState } from 'react';
import { Link } from "react-router-dom";
import { GlobalContext } from '../../GlobalContext';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { methods } from '../../Validation';

const Login = () => {
  const { t, i18n } = useTranslation();
    const [isChecked, setIsChecked] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password:'',
  
      });
         let [formdata_valid_error,setFormDatavalid] = useState({//validName
                       password: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Password required"},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Password min size 8"}],required:true,error:false,errormsg:null
                       },
                       email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Email is required"},
                              {keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please type valid email address"}],error:false,errormsg:null},
               
                     });
      const [errormsg,setErrormsg] = useState(null);
      const [index_dat,setIndex_dat] = useState(1);
      const [index_dat_success,setIndex_dat_success] = useState(1);
         const handleChange = (e) => {
                 const { name, value } = e.target;
                
                 if (name in formdata_valid_error) {
                     if('validtion' in formdata_valid_error[name]){
                    
                       let result = null;
                       let newformdata;
                         for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                             if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                 result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                 }
                            if(result == false){
                             formdata_valid_error[name].error = true;
                             formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                             newformdata = formdata_valid_error[name];
                              setFormDatavalid(prev => ({
                             ...prev,
                             [name]:newformdata
                             }));
                             break;
                            }
                            if(result == true){
                             
                               formdata_valid_error[name].error = false;
                             formdata_valid_error[name].errormsg = null;
                             newformdata = formdata_valid_error[name];
                              setFormDatavalid(prev => ({
                             ...prev,
                             [name]:newformdata
                             }));
                            }
         
                     }
                     
                     }
          
                 }
               
                 setFormData(prev => ({
                   ...prev,
                   [name]: value
                 }));
                 
               };
    const handleChange_chck = (e) => {
    setIsChecked(e.target.checked);
  };

      const handleSubmit = (e) => {
        e.preventDefault(); 
                       let value;
                       for (const name in formData) {
                           value = formData[name];
                           if (name in formdata_valid_error) {
                           if('validtion' in formdata_valid_error[name]){
                          
                             let result = null;
                             let newformdata;
                               for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                                   if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                       result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                       }
                                  if(result == false){
                                   formdata_valid_error[name].error = true;
                                   formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                                   newformdata = formdata_valid_error[name];
                                    setFormDatavalid(prev => ({
                                   ...prev,
                                   [name]:newformdata
                                   }));
                                   break;
                                  }
                                  if(result == true){
                                   
                                     formdata_valid_error[name].error = false;
                                   formdata_valid_error[name].errormsg = null;
                                   newformdata = formdata_valid_error[name];
                                    setFormDatavalid(prev => ({
                                   ...prev,
                                   [name]:newformdata
                                   }));
                                  }
               
                           }
                           
                           }
                
                       }
                           }
               
                           let validation = true;
                            for (const key in formdata_valid_error) {
                               if(formdata_valid_error[key].error == true){
                                  validation = false; 
                                  break;
                               }
                            }
               
                            if(validation){
                                      if(isChecked){
                                          const parent = document.getElementById("iagree");
                                             if (parent) {
                                                parent.parentElement.classList.remove("error");
                                             }
                                handleSubmit_axios(formData);
                                      }else{    
                                          console.log('Form submitted:', 'faild');
                                           const parent = document.getElementById("iagree");
                                             if (parent) {
                                                parent.parentElement.classList.add("error");
                                             }
                              }
                               
                            }else{
                               console.log('Form submitted:', 'faild');
                               console.log('Form submitted:', formData);
                            } 
       
       
      };

         const handleSubmit_forget = (e) => {
        e.preventDefault(); 
        let name = 'email'
          let value = formData[name];
                           if (name in formdata_valid_error) {
                           if('validtion' in formdata_valid_error[name]){
                          
                             let result = null;
                             let newformdata;
                               for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                                   if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                       result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                       }
                                  if(result == false){
                                   formdata_valid_error[name].error = true;
                                   formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                                   newformdata = formdata_valid_error[name];
                                    setFormDatavalid(prev => ({
                                   ...prev,
                                   [name]:newformdata
                                   }));
                                   break;
                                  }
                                  if(result == true){
                                   // console.log(formData.email);
                                     
                                   break;
                                  }
               
                           }

                           handleSubmit_axios_forget(formData.email);
                           
                           }
                
                       }
      
       
      };

      const { siteName } = useContext(GlobalContext);
      let baseUrl = siteName.baseUrl;
      let defult_endpoint = siteName.webEndpoints;

        const handleSubmit_axios_forget = async (email) => {
       
        try {
          let formData_value = {email:email};
          const response = await axios.post(baseUrl+defult_endpoint+'forgot/password', formData_value);
          console.log(response.data);
          let data = response.data.response;

          /*call back data*/
          setIndex_dat_success(2);
          setTimeout(function(){
            window.location.reload();
          },2000)
         
        } catch (error) {
          setErrormsg(error.response.data.message);
          console.log(error.response.data);
          /*error call back*/
        }
      };  

      const handleSubmit_axios = async (formData) => {

       
        try {
          const response = await axios.post(baseUrl+defult_endpoint+'login', formData);
          console.log(response.data);
          let data = response.data.response;

          

          /*call back data*/
          localStorage.setItem('name', data.fullName);
          localStorage.setItem('token', data.accessToken);
          localStorage.setItem('loginbefore', data.hasLoggedInBefore);
          localStorage.setItem('role', data.role);
          if(data.hasLoggedInBefore){
           window.location.reload();
          }else{
            document.body.removeAttribute("style");
            let el = document.querySelector(".modal-backdrop");
           // el.classList.remove("show", " "); 
           if (el) {
  el.remove(); 
}
         window.location.href = '/#/changepassword';
          }
         
        } catch (error) {
          setErrormsg(error.response.data.message);
          console.log(error.response.data);
          /*error call back*/
        }
      };

      
      const email_validation = (validation,value) =>{
        console.log(validation);
        console.log(value);
      };

      const email_validation_data = "email_validation";

      const handleChange_forget = () =>{
   setFormDatavalid({//validName
                       password: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Password required"},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Password min size 8"}],required:true,error:false,errormsg:null
                       },
                       email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Email is required"},
                              {keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please type valid email address"}],error:false,errormsg:null},
               
                     });
 
        setIndex_dat(2)

      } 

      const handleChange_login = () =>{
              setFormDatavalid({//validName
                       password: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Password required"},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Password min size 8"}],required:true,error:false,errormsg:null
                       },
                       email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Email is required"},
                              {keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please type valid email address"}],error:false,errormsg:null},
               
                     });
         setIndex_dat(1)
      }


  return (  
                <div className="modal video-show-modal login-modal fade" id="loginModal"  aria-labelledby="loginModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <Link to="#"><img src="img/CfaN.png" alt=""/></Link>
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                           { index_dat == 1?  <form onSubmit={handleSubmit}>
                                <label htmlFor="username">{t("Email_Address")}</label>
                                <input type="text" validation={JSON.stringify(email_validation_data)} onChange={handleChange} name="email" id="email" placeholder={t("Email_Address")} />
                                 {formdata_valid_error.email.error? <div className="error">{formdata_valid_error.email.errormsg}</div> : ''}
                                <label htmlFor="password">{t("Password")}</label>
                                <input type="password" validation={email_validation_data} onChange={handleChange} name="password" placeholder={t("Password")} id="password"  />
                                 {formdata_valid_error.password.error? <div className="error">{formdata_valid_error.password.errormsg}</div> : ''}
                                { errormsg != null? <div className="error">{errormsg}</div> : '' }
                                <div className="form-agree-statement">
                                    <input checked={isChecked}  onChange={handleChange_chck} id="iagree" type="checkbox"/>
                                    <span>{t("Agree_to_")}</span>
                                </div>
                                <input type="submit" value={t('Login')} />

                                <div className="text-center forgot-password-text">
                                    <Link to="#" onClick={handleChange_forget}>{t("Forgot_My_Password")}</Link>
                                </div>
                            </form>
                              : [ index_dat_success == 1? <form onSubmit={handleSubmit_forget}> 
                                 <label htmlFor="username">{t("Email_Address")}</label>
                                <input type="text" validation={JSON.stringify(email_validation_data)} onChange={handleChange} name="email" id="email" placeholder={t("Email_Address")} />
                                                    
                                {formdata_valid_error.email.error? <div className="error">{formdata_valid_error.email.errormsg}</div> : ''}

                                <input type="submit" value="Submit" />
                                <div className="text-center forgot-password-text">
                                    <Link to="#" onClick={handleChange_login}>{t("login")}</Link>
                                </div>

                              </form> : <div>Send email successfully</div>]  }
                        </div>
                        </div>
                    </div>
                    </div>
  );
};

export default Login;